module.exports = __webpack_public_path__ + "static/media/UserCreation.e3893fe4.xlsx";